import { render, staticRenderFns } from "./MatchList.vue?vue&type=template&id=7dbfc460&scoped=true"
import script from "./MatchList.vue?vue&type=script&lang=js"
export * from "./MatchList.vue?vue&type=script&lang=js"
import style0 from "./MatchList.vue?vue&type=style&index=0&id=7dbfc460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbfc460",
  null
  
)

export default component.exports